<template>
  <CCard class="brands-table">
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton :color="filters ? 'dark' : 'warning'" size="sm" @click="toggleFilters" class="filter-btn-compact"><CIcon name="cil-filter"/></CButton>
          <CButton color="info" size="sm" @click="storeModal()">Nueva Marca</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CRow v-if="filters">
        <CCol md="3"></CCol>
        <CCol md="3"></CCol>
        <CCol md="3"></CCol>
        <CCol md="3">
          <div role="group" class="form-group compact-filter-group">
            <label> Proveedor:</label>
            <CSelect
              :value.sync="providerSelected" 
              :options="providersOptions"
              @change="changeFilters"
            />                        
          </div>
        </CCol>
      </CRow>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="50"
        :tableFilter="tableFilter"
        :dark="dark"
        class="compact-table"
        pagination
      >
        <template #name="{item}"><td class="text-left p-0 compact-cell compact-left-cell">{{item.name}}</td></template>
        <template #provider_name="{item}"><td class="text-center w200 p-0 compact-cell">{{item.provider_name}}</td></template>
        <template #actions="{item}">
          <td class="table_actions p-0 compact-cell">
            <CButton color="warning" size="sm" @click="updateModal(item)"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <BrandModal ref="brandModal" @store="storeProcess" @update="updateProcess"></BrandModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import BrandModal from './BrandModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/brands';
import providers_ws from '../../services/providers';
import store from '../../store'

export default {
  name: 'BrandsTable',
  components: { BrandModal, DeleteModal },
  props: {
    items: Array,
    permissions: Object,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'name', label: 'Nombre'},
          {key: 'provider_name', label: 'Proveedor'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      filters: false,
      toasts: [],
      providers: [],
      providersOptions: [],
      providerSelected: "",
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  mounted: async function() {
    let response = await providers_ws.get(); 

    if(response.type == "success"){
      this.providers = response.data;

      this.providersOptions = await this.$parseSelectOptionsOrdered(this.providers, "id", "name", [{value: '0', label: 'Todos'}]);
    }
  },
  methods: {
    toggleFilters () {
      this.filters = !this.filters;
    },
    async changeFilters () {
      this.loading();

      let filters = this.getFilters();
      let response = await ws.getFiltered(filters);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.loaded();
    },
    getFilters(){
      let filters = {
        provider : this.providerSelected
      };

      return filters;
    },
    storeModal () {
      this.$refs.brandModal.storeModal();
    },
    updateModal (item) {
      this.$refs.brandModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Marca", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      this.changeFilters();

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.changeFilters();
      }

      this.showToast(response.type, response.message);
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style scoped>
.brands-table {
  font-size: 12px;
}

.brands-table :deep(.card-header),
.brands-table :deep(.card-body),
.brands-table :deep(.table),
.brands-table :deep(.table th),
.brands-table :deep(.table td),
.brands-table :deep(.form-control),
.brands-table :deep(.btn),
.brands-table :deep(label) {
  font-size: 12px;
}

.filter-btn-compact {
  height: 26px;
  padding: 2px 5px;
}

.compact-filter-group {
  margin: -10px 0 10px;
}

.compact-table :deep(.table td),
.compact-table :deep(.table th) {
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}

.compact-cell {
  font-size: 12px;
}

.compact-left-cell {
  padding-left: 5px !important;
}
</style>
